var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5967",
    "data-name": "Group 5967",
    transform: "translate(-296.104 -345.176)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13379",
    "data-name": "Path 13379",
    d: "M318.1,424.271a4.585,4.585,0,0,0-.163.887,11.4,11.4,0,0,1-.9,2.8,1.922,1.922,0,0,1-1.9,1.13H299.051a1.984,1.984,0,0,1-1.974-1.3,11.735,11.735,0,0,1-.971-3.813c-.01-.125.018-.162.143-.161.773.005,1.547.01,2.32,0,.2,0,.179.116.189.236a7.91,7.91,0,0,0,.389,1.924.634.634,0,0,0,1.083.263.662.662,0,0,0,.13-.693,7.313,7.313,0,0,1,3.584-8.853,6.727,6.727,0,0,1,7.118.458,6.94,6.94,0,0,1,3.089,4.963,7.219,7.219,0,0,1-.282,3.329.906.906,0,0,0-.047.536.652.652,0,0,0,.608.47.64.64,0,0,0,.619-.453,7.974,7.974,0,0,0,.387-1.858c.028-.316.023-.318.326-.317l2.34.013Zm-12.939.15a2.382,2.382,0,0,0,.128.758,1.929,1.929,0,0,0,3.274.586q2.233-2.537,4.476-5.065a.67.67,0,0,0,.087-.877.645.645,0,0,0-.863-.174q-2.994,1.515-5.984,3.036A1.951,1.951,0,0,0,305.166,424.421Z",
    transform: "translate(0 -66.909)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13380",
    "data-name": "Path 13380",
    d: "M625.181,420.582c-.794,0-1.587-.014-2.381-.008-.175,0-.239-.032-.259-.224a8.208,8.208,0,0,0-1.864-4.457c-.078-.095-.089-.147.008-.241q.806-.788,1.6-1.592c.086-.087.128-.114.225,0a11.181,11.181,0,0,1,2.4,4.658,8.515,8.515,0,0,1,.232,1.394c0,.044-.025.1.044.128Z",
    transform: "translate(-307.076 -65.013)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13381",
    "data-name": "Path 13381",
    d: "M297.435,420.478c-.379,0-.759,0-1.138,0-.126,0-.171-.018-.159-.164a10.987,10.987,0,0,1,1.639-4.952,12.664,12.664,0,0,1,1.043-1.414c.085-.1.125-.067.195,0,.535.538,1.069,1.076,1.612,1.607.1.1.083.148.006.241a8.257,8.257,0,0,0-1.459,2.6,8.121,8.121,0,0,0-.411,1.9c-.015.156-.072.182-.211.179C298.18,420.472,297.808,420.478,297.435,420.478Z",
    transform: "translate(-0.031 -64.921)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13382",
    "data-name": "Path 13382",
    d: "M372.018,345.176v1.162c0,.415-.007.831,0,1.246,0,.145-.049.18-.179.192a8.334,8.334,0,0,0-3.965,1.434c-.2.137-.394.285-.582.439-.088.072-.141.08-.227-.007q-.807-.819-1.626-1.625c-.088-.087-.062-.123.016-.19a11.046,11.046,0,0,1,5.283-2.5C371.158,345.252,371.578,345.218,372.018,345.176Z",
    transform: "translate(-65.561)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13383",
    "data-name": "Path 13383",
    d: "M519.382,348.057c-.577.575-1.156,1.148-1.729,1.727-.106.108-.158.026-.226-.03a8.431,8.431,0,0,0-3.247-1.634,6.943,6.943,0,0,0-1.266-.218c-.134-.009-.2-.036-.2-.2.01-.752.005-1.5,0-2.256,0-.093-.006-.151.131-.141A11.031,11.031,0,0,1,519.33,348,.61.61,0,0,1,519.382,348.057Z",
    transform: "translate(-204.975 -0.126)",
    fill: "#5f5f5f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13384",
    "data-name": "Path 13384",
    d: "M492.116,534.931l-.655.732q-.722.807-1.443,1.615a.625.625,0,0,1-.627.234.659.659,0,0,1-.545-.534.649.649,0,0,1,.4-.669c.82-.415,1.643-.824,2.465-1.236l.375-.185Z",
    transform: "translate(-182.38 -179.325)",
    fill: "#5f5f5f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.df178f7300c14c30a79c8898b6131e9c.svg";
export { ForwardRef as ReactComponent };